export const GET_QUEUES = "GET_QUEUES";
export const START_FETCHING_QUEUES = "START_FETCHING_QUEUES";
export const STOP_FETCHING_QUEUES = "STOP_FETCHING_QUEUES";
export const START_ADDING_QUEUES = "START_ADDING_QUEUES";
export const STOP_ADDING_QUEUES = "STOP_ADDING_QUEUES";
export const SUCCESS_ADDING_QUEUES = "SUCCESS_ADDING_QUEUES";
export const CREATED_QUEUES = "CREATED_QUEUES";
